// Auto-generated skeleton for CraftsmanTaskPerson

import { CraftsmanTaskPersonType } from "./CraftsmanTaskPersonType";
import { Person } from "./Person";
import { CraftsmanTaskPersonContact } from "./CraftsmanTaskPersonContact";
import { Unit } from "./Unit";

export const CraftsmanTaskPerson: Api.CraftsmanTaskPerson = {
  id: 0,
  craftsmant_task_id: 0,
  craftsman_task: null,
  person_type_id: 0,
  person_type: CraftsmanTaskPersonType,
  person_id: 0,
  person: Person,
  contact_persons: [CraftsmanTaskPersonContact],
  unit_id: 0,
  unit: Unit,
  role_id: 0,
  created: null,
  updated: null,
};

